export enum ResponseType {
  Base64 = 'base64',
  ImageFilePath = 'imageFilePath',
}

export enum ScanDocumentResponseStatus {
  Success = 'success',
  Cancel = 'cancel',
}

const DocumentScanner = {
  scanDocument: () => {
    throw new Error(
      'react-native-document-scanner-plugin is not supported on web'
    )
  },
}

export default DocumentScanner
